export default __webpack_public_path__ + "assets/images/1313a8dce2d3022a9775212e434af8ba.png";